export default "__VITE_ASSET__BajAV462__"